var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "99.49 243.36 556.01 316.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 355.5 260.800781 L 655.5 260.800781 L 655.5 549.550781 L 355.5 549.550781 Z M 355.5 260.800781 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 294 439 L 344.738281 439 L 344.738281 490 L 294 490 Z M 294 439 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 99.488281 270 L 170 270 L 170 424 L 99.488281 424 Z M 99.488281 270 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 355.882812 280.625 L 355.882812 335.230469 L 391.28125 335.230469 L 386 368.71875 L 355.882812 368.71875 L 355.882812 423.324219 L 377.390625 423.324219 L 358.277344 544.511719 L 389.558594 549.445312 L 409.449219 423.324219 L 601.546875 423.324219 L 621.4375 549.445312 L 652.722656 544.511719 L 633.609375 423.324219 L 655.117188 423.324219 L 655.117188 368.71875 L 625 368.71875 L 619.71875 335.230469 L 655.117188 335.230469 L 655.117188 280.625 L 611.105469 280.625 L 607.976562 260.800781 L 576.691406 265.734375 L 579.042969 280.625 L 431.957031 280.625 L 434.308594 265.734375 L 403.023438 260.800781 L 399.894531 280.625 Z M 427.234375 414.222656 L 387.191406 414.222656 L 414.855469 377.820312 L 454.898438 377.820312 Z M 511.6875 414.222656 L 471.644531 414.222656 L 499.3125 377.820312 L 539.355469 377.820312 Z M 596.144531 414.222656 L 556.101562 414.222656 L 583.769531 377.820312 L 623.808594 377.820312 Z M 592.9375 368.71875 L 418.0625 368.71875 L 423.34375 335.230469 L 587.652344 335.230469 Z M 583.765625 289.722656 L 623.808594 289.722656 L 596.144531 326.128906 L 556.101562 326.128906 Z M 499.3125 289.722656 L 539.355469 289.722656 L 511.6875 326.128906 L 471.644531 326.128906 Z M 454.898438 289.722656 L 427.234375 326.128906 L 387.191406 326.128906 L 414.855469 289.722656 Z M 454.898438 289.722656 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 192.589844 311.511719 C 186.945312 314.292969 173.402344 322.207031 172.589844 328.914062 C 171.828125 335.089844 160.253906 366.242188 144.015625 382.945312 L 144.015625 406.800781 C 159.945312 397.707031 172.140625 378.816406 180.171875 361.976562 L 181.382812 377.609375 L 192.589844 377.609375 L 192.589844 311.511719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 210.007812 305.925781 L 210.007812 329.671875 L 230.628906 329.671875 L 230.628906 306.488281 C 223.71875 305.085938 216.808594 304.886719 210.007812 305.925781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 186.804688 448.394531 C 186.886719 449.433594 187.535156 450.277344 188.40625 450.726562 C 188.40625 450.839844 188.378906 450.949219 188.378906 451.0625 L 188.378906 545.367188 C 188.378906 553.171875 194.726562 559.515625 202.566406 559.515625 C 210.375 559.515625 216.722656 553.171875 216.722656 545.367188 L 216.722656 451.0625 L 223.917969 451.0625 L 223.917969 545.367188 C 223.917969 553.171875 230.265625 559.515625 238.105469 559.515625 C 245.914062 559.515625 252.261719 553.171875 252.261719 545.367188 L 252.261719 451.0625 C 252.261719 450.949219 252.234375 450.839844 252.207031 450.726562 C 253.078125 450.277344 253.753906 449.40625 253.835938 448.394531 L 254.59375 438.769531 L 186.046875 438.769531 L 186.804688 448.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 197.703125 281.03125 C 222.003906 274.492188 242.710938 280.582031 242.710938 280.582031 C 243.214844 280.132812 248.019531 275.753906 247.515625 276.203125 C 248.414062 257.230469 235.351562 250.496094 235.351562 250.496094 C 228.636719 257.707031 227.625 273.621094 227.316406 274.574219 C 226.191406 255.238281 233.523438 247.632812 233.75 247.097656 C 217.933594 238.679688 207.085938 247.097656 207.085938 247.097656 C 214.644531 257.203125 213.101562 274.015625 213.183594 274.519531 C 210.710938 258.578125 207.398438 255.351562 204.953125 251.222656 C 190.679688 259.363281 193.265625 276.203125 193.265625 276.203125 C 193.714844 276.710938 198.152344 281.535156 197.703125 281.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 197.339844 288.160156 C 201.804688 296.300781 210.402344 301.828125 220.320312 301.828125 C 230.179688 301.828125 238.75 296.355469 243.214844 288.246094 C 244.675781 287.9375 245.492188 287.710938 245.492188 287.710938 L 250.832031 282.015625 L 250.832031 279.851562 L 248.078125 280.050781 C 247.597656 280.554688 242.878906 285.355469 243.386719 284.875 C 218.832031 277.945312 197.3125 284.875 197.3125 284.875 C 196.804688 284.371094 195.089844 282.773438 192.367188 280.050781 L 189.78125 279.851562 L 189.78125 282.519531 L 195.371094 287.710938 C 196.046875 287.90625 196.664062 288.019531 197.339844 288.160156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 243.328125 310.363281 C 240.6875 309.265625 238.019531 308.339844 235.351562 307.609375 L 235.351562 334.414062 L 205.289062 334.414062 L 205.289062 306.851562 C 202.621094 307.527344 199.953125 308.339844 197.3125 309.351562 L 197.3125 382.324219 L 181.886719 382.324219 L 181.886719 384.429688 C 182.28125 389.511719 180.484375 366.046875 185.707031 434.027344 L 254.933594 434.027344 C 254.960938 433.546875 259.035156 378.761719 258.753906 382.324219 L 243.355469 382.324219 L 243.355469 310.363281 L 243.328125 310.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 274.234375 415.082031 C 276.984375 412.414062 280.804688 412.246094 283.417969 413.84375 L 290.527344 417.832031 C 290.722656 360.769531 268.109375 326.050781 267.097656 324.5625 C 265.355469 321.925781 251.898438 314.320312 248.078125 312.496094 L 248.078125 377.609375 L 259.257812 377.609375 L 260.972656 355.4375 C 266.253906 369.667969 271.730469 390.886719 271.621094 417.71875 L 274.234375 415.082031 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 294.824219 476.125 L 299.65625 487.886719 L 301.625 489.824219 L 344.804688 446.683594 L 342.839844 444.71875 L 331.125 439.890625 L 327.132812 443.878906 L 320.980469 440.398438 L 295.359375 466.023438 L 298.816406 472.167969 L 294.824219 476.125 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 293.5625 462.824219 L 317.835938 438.628906 L 306.261719 432.117188 L 287.042969 451.316406 L 293.5625 462.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 285.246094 448.117188 L 303.085938 430.320312 L 291.539062 423.835938 L 278.726562 436.636719 L 285.246094 448.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 281.03125 417.914062 C 279.90625 417.242188 278.53125 417.464844 277.605469 418.390625 L 273.304688 422.742188 C 272.351562 423.613281 272.210938 424.988281 272.828125 426.109375 L 276.929688 433.4375 L 288.363281 422.011719 L 281.03125 417.914062 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.118652%,21.958923%,26.269531%)",
      fillOpacity: 1
    },
    d: "M 151.828125 270.140625 L 116.90625 270.140625 L 99.488281 300.257812 L 116.90625 330.457031 L 129.378906 330.457031 L 129.378906 423.417969 L 139.296875 423.417969 L 139.296875 330.457031 L 151.828125 330.457031 L 169.246094 300.257812 L 151.828125 270.140625 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.1973956a.svg";
export { ForwardRef as ReactComponent };